/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import CustomLayout from "../../Core/Layout/CustomLayout";
import usePermission from "../../Core/hooks/usePermission";
import { PERMISSIONS } from "../Login/constants";
import CommodityList from "./Commodity/CommodityList";
import ToastMessageModal from "./ToastMessageModal";
import { updateRates } from "../../Redux/Slices/rates.slice";
import EnergyList from "./Energy/EnergyList";
import Header from "./Header";
import AgriTechList from "./AgriTechList.jsx/AgriTechList";

function RatesList() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const { showToastMessage } = useSelector((state) => state.rates);

  const selectedTab = searchParams.get("tab");

  // check permission for rate module
  const hasRatesPermission = usePermission([
    PERMISSIONS.RATE_VIEW,
    PERMISSIONS.RATE_VIEW_AND_EDIT,
  ]);

  const getBody = () => {
    if (selectedTab === "commodity") return <CommodityList />;
    if (selectedTab === "energy") return <EnergyList />;
    if (selectedTab === "agri-tech") return <AgriTechList />;

    return <div />;
  };

  // clear the toast message
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        updateRates({
          key: "showToastMessage",
          value: {
            visible: false,
            data: {},
          },
        }),
      );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, showToastMessage.visible]);

  // update the tab selection based on the permission
  useEffect(() => {
    if (!searchParams.has("tab")) {
      if (hasRatesPermission) {
        searchParams.set("tab", "commodity");
        setSearchParams(searchParams);
      }
    }
  }, [searchParams, setSearchParams]);

  return (
    <CustomLayout pageName="Rates Manager">
      <Header />

      {getBody()}

      <ToastMessageModal
        visible={showToastMessage?.visible}
        onCancel={() =>
          dispatch(
            updateRates({
              key: "showToastMessage",
              value: {
                visible: false,
                data: {},
              },
            }),
          )
        }
        title={showToastMessage?.data?.title}
        description={showToastMessage?.data?.description}
      />
    </CustomLayout>
  );
}
export default RatesList;
